import { CashResponse, CashResponseMiddleware } from '@cash-web/shared-util-fetch'

import { FlowResponse, FlowStateDispatch } from '../utils'

export const getTransferToken = (response: CashResponse<FlowResponse>) => {
  return response?.response_context?.transfer?.token
}
export const createSetTransferTokenMiddleware =
  ({ state, dispatch }: FlowStateDispatch): CashResponseMiddleware =>
  (response: CashResponse<FlowResponse>, context) => {
    const transferToken = getTransferToken(response)

    // guard
    if (transferToken == null || transferToken === state.transferToken) {
      return response
    }

    // action
    dispatch({
      type: 'SET_TRANSFER_TOKEN',
      transferToken,
    })

    return response
  }
